"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
var _typeof = require("@babel/runtime/helpers/typeof");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _slicedToArray2 = _interopRequireDefault(require("@babel/runtime/helpers/slicedToArray"));
var _react = _interopRequireWildcard(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
require("chart.js/auto");
var _reactChartjs = require("react-chartjs-2");
var _FormatCurrency = _interopRequireDefault(require("../../currency/FormatCurrency"));
var _Select = _interopRequireDefault(require("../Form/Select"));
var _FormToggle = _interopRequireDefault(require("../Form/FormToggle"));
var _Card = _interopRequireDefault(require("../Card/Card"));
var _constants = require("../constants");
var _hooks = require("../../helpers/hooks");
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != _typeof(e) && "function" != typeof e) return { "default": e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n["default"] = e, t && t.set(e, n), n; }
var FeeChart = function FeeChart(_ref) {
  var data = _ref.data,
    title = _ref.title;
  var _useState = (0, _react.useState)(data[0]),
    _useState2 = (0, _slicedToArray2["default"])(_useState, 2),
    activeDestination = _useState2[0],
    setActiveDestination = _useState2[1];
  var _useState3 = (0, _react.useState)(false),
    _useState4 = (0, _slicedToArray2["default"])(_useState3, 2),
    showCatamaran = _useState4[0],
    setShowCatamaran = _useState4[1];
  var width = (0, _hooks.useWindowWidth)();
  function handleDestinationSelect(e) {
    var d = e.target.value;
    var selectedDest = data.filter(function (dest) {
      return dest.acf.title === d;
    });
    setActiveDestination(selectedDest[0]);
  }
  var toggleType = function toggleType() {
    setShowCatamaran(function (current) {
      return !current;
    });
  };
  var monohullTotal = 0;
  var monohullMap = {};
  var catamaranTotal = 0;
  var catamaranMap = {};
  activeDestination.acf.fees.forEach(function (fee) {
    monohullTotal += parseInt(fee.price, 10);
    monohullMap[fee.title] = fee.price;
  });
  activeDestination.acf.catamaranfees.forEach(function (fee) {
    catamaranTotal += parseInt(fee.price, 10);
    catamaranMap[fee.title] = fee.price;
  });
  var monohullPrices = [];
  activeDestination.acf.fees.map(function (m) {
    return monohullPrices.push(m.price);
  });
  var monohullLabels = [];
  activeDestination.acf.fees.map(function (m) {
    return monohullLabels.push(m.title);
  });
  var catamaranPrices = [];
  activeDestination.acf.catamaranfees.map(function (m) {
    return catamaranPrices.push(m.price);
  });
  var catamaranLabels = [];
  activeDestination.acf.catamaranfees.map(function (m) {
    return catamaranLabels.push(m.title);
  });
  var chartData = {
    labels: showCatamaran ? catamaranLabels : monohullLabels,
    datasets: [{
      data: showCatamaran ? catamaranPrices : monohullPrices,
      backgroundColor: ['#026DD6', '#44DB5E', '#FFCF5C', '#83C3FE'],
      hoverBackgroundColor: ['#026DD6', '#44DB5E', '#FFCF5C', '#83C3FE']
    }]
  };
  return /*#__PURE__*/_react["default"].createElement(_react["default"].Fragment, null, /*#__PURE__*/_react["default"].createElement("div", {
    className: "flex justify-center max-width-xxxxs margin-auto items-center margin-bottom-md"
  }, /*#__PURE__*/_react["default"].createElement("p", {
    className: "margin-right-xs margin-top-xs"
  }, "Monohull"), /*#__PURE__*/_react["default"].createElement(_FormToggle["default"], {
    className: "d8-c-toggle-blue",
    label: "Monohull",
    name: "Monohull",
    checked: showCatamaran,
    onChange: toggleType,
    labelHidden: true
  }), /*#__PURE__*/_react["default"].createElement("p", {
    className: "margin-left-xs margin-top-xs"
  }, "Catamaran")), /*#__PURE__*/_react["default"].createElement(_Card["default"], null, /*#__PURE__*/_react["default"].createElement("div", {
    className: "flex@sm margin-bottom-sm items-center"
  }, title && /*#__PURE__*/_react["default"].createElement("h2", {
    className: "text-md margin-bottom-md d8-u-ls-sm flex-grow"
  }, title), /*#__PURE__*/_react["default"].createElement(_Select["default"], {
    labelHidden: true,
    id: "00N1v00000SFTqZ",
    name: "00N1v00000SFTqZ",
    label: "Your question is relased to",
    value: activeDestination.acf.title,
    onChange: function onChange(e) {
      return handleDestinationSelect(e);
    },
    options: data.map(function (d) {
      return {
        value: d.acf.title,
        text: d.acf.title
      };
    })
  })), /*#__PURE__*/_react["default"].createElement("div", {
    className: "flex flex-column flex-row@sm items-center flex-gap-md"
  }, /*#__PURE__*/_react["default"].createElement("div", {
    className: "col"
  }, /*#__PURE__*/_react["default"].createElement("div", {
    className: "component-padding"
  }, /*#__PURE__*/_react["default"].createElement(_reactChartjs.Doughnut, {
    data: chartData,
    options: {
      cutoutPercentage: 70,
      legend: {
        display: false
      },
      title: {
        display: false
      },
      hoverBackgroundColor: '#fff',
      hoverBorderColor: '#fff',
      tooltips: {
        enabled: width > _constants.BREAKPOINTS.MD,
        backgroundColor: '#ffffff',
        bodyFontColor: 'hsl(220, 8%, 55%)',
        bodyFontFamily: 'sofia-pro, sans-serif',
        borderWidth: 1,
        borderColor: 'hsl(0, 0%, 96%)',
        xPadding: 20,
        yPadding: 20,
        displayColors: false
      }
    },
    height: 300 // no idea why...
  }))), /*#__PURE__*/_react["default"].createElement("div", {
    className: "col"
  }, /*#__PURE__*/_react["default"].createElement("div", {
    className: "grid grid-gap-sm"
  }, showCatamaran ? /*#__PURE__*/_react["default"].createElement(_react["default"].Fragment, null, /*#__PURE__*/_react["default"].createElement("p", {
    className: "d8-u-text-bold text-xl margin-bottom-sm"
  }, /*#__PURE__*/_react["default"].createElement(_FormatCurrency["default"], {
    amount: catamaranTotal,
    baseCurrency: "EUR"
  }), " total"), /*#__PURE__*/_react["default"].createElement("p", {
    className: "d8-u-text-bold text-lg d8-u-color-contrast-high margin-bottom-md"
  }, /*#__PURE__*/_react["default"].createElement(_FormatCurrency["default"], {
    amount: catamaranTotal / 10,
    baseCurrency: "EUR"
  }), " total per person"), activeDestination.acf.catamaranfees.map(function (f, i) {
    return /*#__PURE__*/_react["default"].createElement("div", {
      key: JSON.stringify(f),
      className: "col-6"
    }, /*#__PURE__*/_react["default"].createElement("div", {
      className: "flex items-center"
    }, /*#__PURE__*/_react["default"].createElement("span", {
      className: "margin-x-sm fee-key fee-key-".concat(i + 1)
    }), /*#__PURE__*/_react["default"].createElement("div", null, /*#__PURE__*/_react["default"].createElement("span", {
      className: "d8-u-color-contrast-high"
    }, f.title), /*#__PURE__*/_react["default"].createElement("br", null), /*#__PURE__*/_react["default"].createElement("strong", null, /*#__PURE__*/_react["default"].createElement(_FormatCurrency["default"], {
      amount: f.price,
      baseCurrency: "EUR"
    })))));
  })) : /*#__PURE__*/_react["default"].createElement(_react["default"].Fragment, null, /*#__PURE__*/_react["default"].createElement("p", {
    className: "d8-u-text-bold text-xl margin-bottom-sm"
  }, /*#__PURE__*/_react["default"].createElement(_FormatCurrency["default"], {
    amount: monohullTotal,
    baseCurrency: "EUR"
  }), " total"), /*#__PURE__*/_react["default"].createElement("p", {
    className: "d8-u-text-bold text-lg d8-u-color-contrast-high margin-bottom-md"
  }, /*#__PURE__*/_react["default"].createElement(_FormatCurrency["default"], {
    amount: monohullTotal / 10,
    baseCurrency: "EUR"
  }), " total per person"), activeDestination.acf.fees.map(function (f, i) {
    return /*#__PURE__*/_react["default"].createElement("div", {
      key: JSON.stringify(f),
      className: "col-6"
    }, /*#__PURE__*/_react["default"].createElement("div", {
      className: "flex items-center"
    }, /*#__PURE__*/_react["default"].createElement("span", {
      className: "margin-x-sm fee-key fee-key-".concat(i + 1)
    }), /*#__PURE__*/_react["default"].createElement("div", null, /*#__PURE__*/_react["default"].createElement("span", {
      className: "d8-u-color-contrast-high"
    }, f.title), /*#__PURE__*/_react["default"].createElement("br", null), /*#__PURE__*/_react["default"].createElement("strong", null, /*#__PURE__*/_react["default"].createElement(_FormatCurrency["default"], {
      amount: f.price,
      baseCurrency: "EUR"
    })))));
  })))))));
};
FeeChart.propTypes = {
  data: _propTypes["default"].object.isRequired,
  title: _propTypes["default"].string
};
var _default = exports["default"] = FeeChart;